import { Badge } from '@/components/ui/badge';

interface ModuleStatusBadgeProps {
  status: 'not_started' | 'in_progress' | 'completed';
}

export function ModuleStatusBadge({ status }: ModuleStatusBadgeProps) {
  if (status === 'completed') {
    return <Badge variant="success">Completed</Badge>;
  }
  if (status === 'in_progress') {
    return <Badge variant="outline">In Progress</Badge>;
  }
  return <Badge variant="secondary">Not Started</Badge>;
}
